import { Component, Element, h, Host } from '@stencil/core'

import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * O br-table-header é um subcomponente estrutural da tabela, responsável por agrupar as linhas de cabeçalho da tabela, representadas pelo subcomponente br-table-row.
 * Ele é utilizado para organizar e estruturar o conteúdo do cabeçalho da tabela, permitindo a definição de múltiplas linhas de cabeçalho, cada uma contendo células de cabeçalho representadas pelo subcomponente br-table-header-cell.
 *
 * @remarks
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/table?tab=designer).
 *
 * @Slot default: Área para inclusão do subcomponente br-table-row, que representa as linhas do cabeçalho da tabela.
 */
@Component({
  tag: 'br-table-header',
  styleUrl: 'table-header.scss',
  shadow: true,
})
export class TableHeader {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el!: HTMLBrTableHeaderElement

  /**
   * Retorna o mapa de classes base do componente.
   *
   * @returns Um objeto representando as classes CSS a serem aplicadas ao elemento do cabeçalho da tabela.
   */
  private getHeaderCssClassMap(): CssClassMap {
    return {
      'br-table-header': true,
    }
  }

  /**
   * Renderiza o host do componente.
   *
   * @returns JSX.Element representando o elemento host do componente, contendo a estrutura do cabeçalho da tabela.
   */
  render() {
    return (
      <Host role="rowgroup">
        <div class={this.getHeaderCssClassMap()} role="presentation">
          <slot></slot>
        </div>
      </Host>
    )
  }
}
